import { SVGProps } from "react";

export const TikTokIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
  </svg>
);

export const GoogleIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
    <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
    <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
    <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
  </svg>
);

export const YelpIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path d="M20.16 12.594l-4.995 1.433c-.96.276-1.74-.8-1.176-1.63l2.905-4.308a1.072 1.072 0 0 1 1.596-.206 9.194 9.194 0 0 1 2.364 3.252 1.073 1.073 0 0 1-.694 1.459zm-3.005 5.69a9.157 9.157 0 0 1-2.88 2.685 1.073 1.073 0 0 1-1.525-.471l-2.27-4.652c-.44-.9.484-1.874 1.397-1.473l5.15 2.27c.68.3.8 1.2.128 1.641zm-9.02 1.873A9.2 9.2 0 0 1 4.24 16.18a1.073 1.073 0 0 1 .79-1.404l5.163-.93c.997-.18 1.652.99 .99 1.768l-3.1 3.96c-.5.64-1.478.578-1.948-.417zM3.627 9.293A9.158 9.158 0 0 1 5.47 5.704a1.072 1.072 0 0 1 1.635.14l3.035 4.216c.587.815-.097 1.924-1.033 1.678L4.2 10.612a1.073 1.073 0 0 1-.573-1.319zm7.412-7.537a1.073 1.073 0 0 1 1.096-.76c1.52.117 2.996.588 4.313 1.4a1.073 1.073 0 0 1 .292 1.583l-3.498 4.584c-.536.7-1.647.39-1.678-.468l-.245-5.58c-.024-.27.07-.53.255-.76z" />
  </svg>
);

export const AngiIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <circle cx="12" cy="12" r="11" />
    <path d="M13.2 6L8.4 18h2.4l1.1-2.8h4.2L17.2 18h2.4L14.8 6h-1.6zm.8 2.4l1.5 4.8h-3z" fill="black" />
  </svg>
);
